module.exports = __webpack_public_path__ + "static/media/undraw_add_content_d1tf.eda1ee22.svg";